<template>
  <div class="container">
    <div class="col-12 u-h-100">
      <div class="row u-h-100 u-align-items-center u-justify-content-center u-text-align-center">
        <div class="col-12 col-md-8">
          <h1 class="u-color--white">{{ $t('splash.title') }}</h1>
          <p class="subtitle u-color--white">{{ $t('splash.introduction') }}</p>
          <div class="btn btn--primary" @click="openSteps">{{ $t('splash.get_started') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './../sass/main.scss';
.container {
  height: 100%;
  //min-height: 100vh;
  min-height: 600px;
  background-image: url("../assets/images/splash_bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
</style>

<script>
export default {
  name: "SplashPage",
  methods: {
    openSteps () {
      this.$router.push("/steps");
    }
  }
}
</script>
